// Button bitflags packed into a u16 on the wire.
export const BTN_UP = 1 << 0;
export const BTN_DOWN = 1 << 1;
export const BTN_LEFT = 1 << 2;
export const BTN_RIGHT = 1 << 3;
// Soldiers run by default (Medal of Honor style); holding WALK slows them to
// a careful walk with better accuracy. (Was BTN_RUN with the opposite
// meaning until 2026-10-03; PROTOCOL_VERSION was bumped for it.)
export const BTN_WALK = 1 << 4;
export const BTN_FIRE = 1 << 5;
export const BTN_LEAN_LEFT = 1 << 6;
export const BTN_LEAN_RIGHT = 1 << 7;
export const BTN_JUMP = 1 << 8;

// Not a button: a per-input mode flag chosen by the player in settings.
// Set   -> screen-relative movement (W is always up on the screen).
// Clear -> aim-relative movement (W is toward the cursor, FPS style).
export const FLAG_SCREEN_RELATIVE = 1 << 9;

export const BTN_RELOAD = 1 << 10;
// Press edge: rifle <-> grenade (WEAPON_SWITCH_TICKS of nothing in between).
export const BTN_SWITCH = 1 << 11;
